$(document).ready(function () {
    const swiper = new Swiper('.c-product__gallery--container', {
        // Optional parameters
        centeredSlides: true,
        slidesPerView: '1',
        spaceBetween: 0,
        grabCursor: true,

        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: '1',
                spaceBetween: 0,
            },
            // when window width is >= 899px
            900: {
                slidesPerView: '1',
                spaceBetween: 0,
            }
        },

        pagination: {
            el: '.c-product__gallery--swiper-pagination',
            type: 'bullets',
        },
    
        // Navigation arrows
        navigation: {
            nextEl: '.c-product__gallery--button-next',
            prevEl: '.c-product__gallery--button-prev',
        }
    });
    
    $('.color-swatch').click(function(){
        $dataColor = $(this).data('option');
        $('.product__selected_option').html($dataColor);
    })
})